module.exports = __webpack_public_path__ + "static/media/LogoPlayMachines1.bbed0e18.png";